var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2420_65614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FF6C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 45.6643 99.448 41.4574 98.4107 37.4459L76.0039 15.0391L23.9961 84.9609L37.4459 98.4107C41.4574 99.4481 45.6643 100 50 100C77.6143 100 100 77.6143 100 50Z",
    fill: "#F92814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9961 15.0391H76.0041V84.9609H23.9961V15.0391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 15.0391H76.0037V84.9609H49.9998V15.0391ZM32.2295 61.4762H45.7193V74.966H32.2295V61.4762Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2803 61.4766H67.7701V74.9664H54.2803V61.4766Z",
    fill: "#CDD2E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4633 75.9465L51.2832 67.7662L55.4264 63.623L59.4633 67.66L70.7736 56.3496L74.9168 60.4928L59.4633 75.9465Z",
    fill: "#00C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2295 24.6953H67.7699V30.5547H32.2295V24.6953Z",
    fill: "#BEC3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 24.6953H67.7701V30.5547H50V24.6953Z",
    fill: "#AFB4C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2295 35.8828H67.7699V41.7422H32.2295V35.8828Z",
    fill: "#BEC3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.8828H67.7701V41.7422H50V35.8828Z",
    fill: "#AFB4C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2295 47.0703H67.7699V52.9297H32.2295V47.0703Z",
    fill: "#BEC3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 47.0703H67.7701V52.9297H50V47.0703Z",
    fill: "#AFB4C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2420_65614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/Survey.8dd57a9a521b4471f54f1804939891b9.svg";
export { ForwardRef as ReactComponent };